module.exports = __webpack_public_path__ + "static/img/download_bg_05.df0d03c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_bg_05.png
// module id = OvDZ
// module chunks = 1